import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faStar } from '@fortawesome/pro-solid-svg-icons';
import {
  OverlayTrigger,
  Tooltip,
  DropdownButton,
  MenuItem,
  ButtonGroup
} from 'react-bootstrap';

import CallContactLink from 'components/click_to_call/call_contact_link';
import SelectableRow from 'components/selectable_record_table/selectable_row';
import InitialsBubble from 'components/initials_bubble';

import { valueOrPlaceholder } from 'helpers/string_helpers';
import { clickAsLink } from 'helpers/link_helpers';
import { isPresent } from 'helpers/string_helpers';

import { toggleSelectPerson } from '../store/actions/select_list';
import { map, sortBy } from 'lodash';

export class PersonRow extends React.Component {
  static propTypes = {
    allPeopleIds: PropTypes.array.isRequired,
    callId: PropTypes.number,
    canPreview: PropTypes.func.isRequired, // TODO: Convert to boolean prop
    className: PropTypes.string,
    crmEmail: PropTypes.string,
    currentColumns: PropTypes.array.isRequired,
    currentUser: PropTypes.object.isRequired,
    person: PropTypes.shape({
      canAccessCrm: PropTypes.bool.isRequired,
      company: PropTypes.shape({
        showPath: PropTypes.string
      }),
      companyName: PropTypes.string,
      emailAddresses: PropTypes.arrayOf(PropTypes.shape({
        email: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        primary: PropTypes.bool
      })).isRequired,
      id: PropTypes.number.isRequired,
      initials: PropTypes.string,
      jobTitle: PropTypes.string,
      lastContacted: PropTypes.string,
      mobilePhone: PropTypes.string,
      mobilePhoneNormalized: PropTypes.string,
      name: PropTypes.string,
      officePhone: PropTypes.string,
      officePhoneNormalized: PropTypes.string,
      phone: PropTypes.string,
      phoneNormalized: PropTypes.string,
      phoneNumbers: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        number: PropTypes.string.isRequired,
        numberNormalized: PropTypes.string.isRequired,
        primary: PropTypes.bool
      })),
      searchResults: PropTypes.object,
      showPath: PropTypes.string.isRequired,
      tags: PropTypes.array.isRequired
    }).isRequired,
    selected: PropTypes.bool.isRequired,
    updatePreviewOverlay: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  handleClick = (e) => {
    const { allPeopleIds, person: { showPath, id } } = this.props;

    const offset = allPeopleIds.findIndex(num => num == id);
    const href = `${showPath}?offset=${offset}`;

    if (href) {
      clickAsLink(window, href, e);
    }
  };

  handleEmail = (e) => {
    e.preventDefault();
    window.open(e.target.href);
  };

  handlePreview = () => {
    const {
      person: { id },
      updatePreviewOverlay
    } = this.props;

    updatePreviewOverlay(id);
  };

  handleSelect = () => {
    const { person, onSelect } = this.props;
    if (onSelect != null) {
      onSelect(person);
    }
  };

  render() {
    const { className, person, selected } = this.props;

    return (
      <SelectableRow className={className} selected={selected} onChange={this.handleSelect}>
        <td className="auto-size hidden-sm hidden-xs">
          <InitialsBubble preview={false} text={person.initials} />
        </td>
        <td>
          <strong className="contact-link" onClick={this.handleClick}>
            {valueOrPlaceholder(person.name || person.email)}
          </strong>
          <span className="visible-xs visible-sm text-muted">
            {person.companyName}
          </span>
        </td>
        <td className="auto-size hidden-xs hidden-sm">
          {this.renderPreviewButton()}
        </td>
        {this.renderContactLinks()}
        <td className="hidden-xs hidden-sm">
          {valueOrPlaceholder(person.databaseName)}
        </td>
        <td className="auto-size hidden-xs hidden-sm">
          {valueOrPlaceholder(person.email)}
        </td>
        <td className="hidden-xs hidden-sm">
          <span className="overflow-span">
            {valueOrPlaceholder(person.jobTitle)}
          </span>
        </td>
        <td className="hidden-xs hidden-sm">
          {this.renderCompanyLink(person)}
        </td>
        <td className="hidden-xs hidden-sm">
          <span className="overflow-span">
            {valueOrPlaceholder(person.lastContacted)}
          </span>
        </td>
        {this.renderSearchResults()}
        {this.renderCurrentColumns()}
      </SelectableRow>
    );
  }

  renderCurrentColumns() {
    const { currentColumns, person } = this.props;

    const columns = [];

    currentColumns.forEach((column) => {
      columns.push(
        <td className="hidden-xs hidden-sm">
          {valueOrPlaceholder(person[column])}
        </td>
      );
    });

    return columns;
  }

  renderPreviewButton() {
    const { callId, canPreview } = this.props;

    let tooltipPrompt;
    if (callId) tooltipPrompt = 'You cannot preview another contact while on a call';
    const previewToolTip = (
      <Tooltip id="preview-tooltip" placement="top">
        <span>
          {tooltipPrompt}
        </span>
      </Tooltip>
    );

    if (callId) {
      return (
        <OverlayTrigger overlay={previewToolTip} placement="top">
          <button
            className="btn btn-sm btn-hover btn-muted disabled"
          >
            PREVIEW
          </button>
        </OverlayTrigger>
      );
    } else {
      return (
        <button
          className="btn btn-sm btn-hover btn-muted"
          disabled={!canPreview()}
          onClick={this.handlePreview}
        >
          PREVIEW
        </button>
      );
    }
  }

  renderCompanyLink(person) {
    if (person.company) {
      return (
        <a className="contact-link overflow-span" href={person.company.showPath} name="company-info">
          {valueOrPlaceholder(person.companyName)}
        </a>
      );
    } else {
      return (
        <span className="overflow-span" name="company-info">
          {valueOrPlaceholder(person.companyName)}
        </span>
      );
    }
  }

  renderContactLinks() {
    return (
      <td>
        {this.props.person.canAccessCrm && (
          <ButtonGroup bsSize="small" className="contact-links d-inline-flex" name="contactLinks">
            {this.renderEmailDropdown()}
            {this.renderPhoneDropdown()}
          </ButtonGroup>
        )}
      </td>
    );
  }

  renderEmailDropdown() {
    const { id } = this.props.person;
    let { emailAddresses } = this.props.person;
    if (!emailAddresses || emailAddresses.length === 0) return;

    emailAddresses = sortBy(emailAddresses, emailAddress => [emailAddress.primary ? 0 : 1, emailAddress.label]);

    const emailItems = map(emailAddresses, (emailAddress) => {
      const emailId = 'email-' + [emailAddress.label, emailAddress.email].join(':');
      return (
        <MenuItem
          href={`mailto:?bcc=${emailAddress.email}`}
          key={emailId}
          name={emailId}
          onClick={this.handleEmail}
        >
          {emailAddress.email}
          <span className="ml-2 mr-2 text-muted">{emailAddress.label}</span>
          {emailAddress.primary && <FontAwesomeIcon className="text-primary-alt" icon={faStar} title='Primary' />}
        </MenuItem>
      );
    });

    return (
      <DropdownButton
        className="btn btn-sm btn-default contact-icons"
        id={`person${id}-email-dropdown`}
        title={<FontAwesomeIcon className="right-buffer-sm" icon={faEnvelope} />}
      >
        {emailItems}
      </DropdownButton>
    );
  }

  renderPhoneDropdown() {
    const { id, name } = this.props.person;
    let { phoneNumbers } = this.props.person;
    if (!phoneNumbers || phoneNumbers.length === 0) return;

    phoneNumbers = sortBy(phoneNumbers, phoneNumber => [phoneNumber.primary ? 0 : 1, phoneNumber.label]);

    const phoneItems = map(phoneNumbers, (phoneNumber) => {
      const phoneId = 'phone-' + [phoneNumber.label, phoneNumber.numberNormalized].join();
      return (
        <MenuItem key={phoneId} name={phoneId}>
          <CallContactLink
            fax={phoneNumber.fax}
            phone={phoneNumber.number}
            phoneNormalized={phoneNumber.numberNormalized}
            targetName={name}
            user={this.props.currentUser}
          />
          <span className="ml-2 mr-2 text-muted">{phoneNumber.label}</span>
          {phoneNumber.primary && <FontAwesomeIcon className="text-primary-alt" icon={faStar} title='Primary' />}
        </MenuItem>
      );
    });

    return (
      <DropdownButton
        className="contact-icons"
        id={`person${id}-phone-dropdown`}
        title={<FontAwesomeIcon className="right-buffer-sm" icon={faPhone} />}
      >
        {phoneItems}
      </DropdownButton>
    );
  }

  renderSearchResults() {
    const { person } = this.props;

    if (person && person.searchResults) {
      const highlights = Object.entries(person.searchResults);

      if (highlights.length > 0) {
        const [label, value] = highlights[0];
        const formattedValue = <span dangerouslySetInnerHTML={{ __html: value }} />;

        if (isPresent(label)) {
          return (
            <td name="search-results">
              <span name="search-result-label">{label}:</span>&nbsp;
              <span name="search-result-value">"{formattedValue}"</span>
            </td>
          );
        } else {
          return (
            <td name="search-results">
              <span name="search-result-value">
                {formattedValue}
              </span>
            </td>
          );
        }
      }
    }
  }
}

const mapStateToProps = state => ({
  allPeopleIds: state.search.meta.people.allIds,
  callId: state.ui.previewOverlayCallId,
  crmEmail: state.static.crmEmail,
  currentColumns: state.session.currentColumns,
  currentUser: state.static.currentUser
});

const mapDispatchToProps = {
  onSelect: toggleSelectPerson,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonRow);
